// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/sun.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/k.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Work_work__1yJmT {
  display: block;
  margin: 60px 0 0 0;
}
@media (max-width: 740px) {
  .Work_work__1yJmT {
    margin: 60px 0;
  }
}
.Work_work__1yJmT .Work_box_work__RzRTr {
  position: relative;
  aspect-ratio: 3/2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_center__5QzAY {
  min-width: 28rem;
  min-height: 21rem;
  width: 60%;
  aspect-ratio: 3/2;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  color: var(--chervonyy, #CC2E2E);
  font-size: 1.4rem;
  font-family: Rubik Glitch;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 800px) {
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_center__5QzAY {
    min-width: 25rem;
    min-height: 18rem;
    width: 50%;
    font-size: 1.3rem;
  }
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY {
  max-width: 15rem;
  position: absolute;
}
@media (max-width: 740px) {
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY {
    position: static;
  }
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(1) {
  left: 29%;
  bottom: 83%;
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(2) {
  left: 73%;
  top: 17%;
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(3) {
  max-width: 12rem;
  left: 79%;
  top: 55%;
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(4) {
  left: 60%;
  top: 80%;
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(5) {
  right: 53%;
  top: 83%;
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(6) {
  max-width: 12rem;
  right: 77%;
  bottom: 27%;
}
.Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(7) {
  right: 77%;
  top: 26%;
}
@media (max-width: 740px) {
  .Work_work__1yJmT .Work_box_work__RzRTr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_center__5QzAY {
    width: 100%;
    min-width: 0px;
    max-width: 380px;
    margin: 0 auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    grid-row: 3/4;
    grid-column: 1/3;
    padding-bottom: 40px;
    margin-block: -30px -50px;
    font-size: 1.7rem;
  }
}
@media (max-width: 740px) and (max-width: 480px) {
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_center__5QzAY {
    max-width: 260px !important;
    margin-block: -75px -90px;
    font-size: 1.5rem;
  }
}
@media (max-width: 740px) {
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY {
    box-sizing: border-box;
    border-radius: 15px;
    background: #FFF;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.07), 0px -4px 10px 0px rgba(255, 255, 255, 0.15);
    max-width: 100% !important;
    padding: 14px 16px;
  }
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(2) {
    align-self: flex-end;
  }
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(3) {
    grid-row: 2/3;
    grid-column: 1/3;
  }
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(4) {
    align-self: flex-end;
  }
  .Work_work__1yJmT .Work_box_work__RzRTr .Work_block__rQBvY:nth-child(6) {
    align-self: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Work/Work.module.scss"],"names":[],"mappings":"AAAA;EACG,cAAA;EACA,kBAAA;AACH;AACG;EAJH;IAKM,cAAA;EAEJ;AACF;AAAG;EACG,kBAAA;EAEA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACN;AACM;EACG,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EAGA,gCAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADT;AAGS;EArBH;IAsBM,gBAAA;IACA,iBAAA;IACA,UAAA;IACA,iBAAA;EAAV;AACF;AAGM;EAEG,gBAAA;EACA,kBAAA;AAFT;AAIS;EALH;IAMM,gBAAA;EADV;AACF;AAIM;EACG,SAAA;EACA,WAAA;AAFT;AAKM;EACG,SAAA;EACA,QAAA;AAHT;AAMM;EACG,gBAAA;EACA,SAAA;EACA,QAAA;AAJT;AAOM;EACG,SAAA;EACA,QAAA;AALT;AAQM;EACG,UAAA;EACA,QAAA;AANT;AASM;EACG,gBAAA;EACA,UAAA;EACA,WAAA;AAPT;AAUM;EAEG,UAAA;EACA,QAAA;AATT;AAYM;EArFH;IAsFM,aAAA;IACA,8BAAA;IACA,SAAA;EATP;EAYO;IACG,WAAA;IACA,cAAA;IACA,gBAAA;IAEA,cAAA;IACA,yDAAA;IACA,aAAA;IACA,gBAAA;IACA,oBAAA;IACA,yBAAA;IACA,iBAAA;EAXV;AACF;AAYY;EAbH;IAcM,2BAAA;IACA,yBAAA;IACA,iBAAA;EATb;AACF;AAdM;EA0BG;IACG,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,6FAAA;IACA,0BAAA;IACA,kBAAA;EATV;EAYO;IACG,oBAAA;EAVV;EAYO;IACG,aAAA;IACA,gBAAA;EAVV;EAYO;IACG,oBAAA;EAVV;EAYO;IACG,sBAAA;EAVV;AACF","sourcesContent":[".work {\n   display: block;\n   margin: 60px 0 0 0;\n\n   @media (max-width: 740px) {\n      margin: 60px 0;\n   }\n\n   .box_work {\n      position: relative;\n      // height: 600px;\n      aspect-ratio: 3 / 2;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      \n      .center{\n         min-width: 28rem;\n         min-height: 21rem;\n         width: 60%;\n         aspect-ratio: 3 / 2;\n         display: flex;\n         align-items: center;\n         justify-content: center;\n         background-image: url(\"../../assets//images/sun.png\");\n         background-position: center;\n         background-size: contain;\n         background-repeat: no-repeat;\n         // border: 1px dashed black;\n\n         color: var(--chervonyy, #CC2E2E);\n         font-size: 1.4rem;\n         font-family: Rubik Glitch;\n         font-style: normal;\n         font-weight: 400;\n         line-height: normal;\n\n         @media (max-width: 800px) {\n            min-width: 25rem;\n            min-height: 18rem;\n            width: 50%;\n            font-size: 1.3rem;\n         }\n      }\n\n      .block {\n         // border: 1px dashed black;\n         max-width: 15rem;\n         position: absolute;\n\n         @media (max-width: 740px) {\n            position: static;\n         }\n      }\n\n      .block:nth-child(1) {\n         left: 29%;\n         bottom: 83%;\n      }\n\n      .block:nth-child(2) {\n         left: 73%;\n         top: 17%;\n      }\n\n      .block:nth-child(3) {\n         max-width: 12rem;\n         left: 79%;\n         top: 55%;\n      }\n\n      .block:nth-child(4) {\n         left: 60%;\n         top: 80%;\n      }\n\n      .block:nth-child(5) {\n         right: 53%;\n         top: 83%;\n      }\n\n      .block:nth-child(6) {\n         max-width: 12rem;\n         right: 77%;\n         bottom: 27%;\n      }\n\n      .block:nth-child(7) {\n         // max-width: 12rem;\n         right: 77%;\n         top: 26%;\n      }\n\n      @media (max-width: 740px) {\n         display: grid;\n         grid-template-columns: 1fr 1fr;\n         gap: 20px;\n\n\n         .center{\n            width: 100%;\n            min-width: 0px;\n            max-width: 380px;\n            // border: 1px solid red;\n            margin: 0 auto;\n            background-image: url('../../assets/images/k.png');\n            grid-row: 3 / 4;\n            grid-column: 1 / 3;\n            padding-bottom: 40px;\n            margin-block: -30px -50px;\n            font-size: 1.7rem;\n\n            @media (max-width: 480px) {\n               max-width: 260px !important;\n               margin-block: -75px -90px;\n               font-size: 1.5rem;\n            }\n         }\n\n         .block{\n            box-sizing: border-box;\n            border-radius: 15px;\n            background: #FFF;\n            box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.07), 0px -4px 10px 0px rgba(255, 255, 255, 0.15);\n            max-width: 100% !important;\n            padding: 14px 16px;\n         }\n\n         .block:nth-child(2) {\n            align-self: flex-end;\n         }\n         .block:nth-child(3) {\n            grid-row: 2 / 3;\n            grid-column: 1 / 3;\n         }\n         .block:nth-child(4) {\n            align-self: flex-end;\n         }\n         .block:nth-child(6) {\n            align-self: flex-start;\n         }\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"work": `Work_work__1yJmT`,
	"box_work": `Work_box_work__RzRTr`,
	"center": `Work_center__5QzAY`,
	"block": `Work_block__rQBvY`
};
export default ___CSS_LOADER_EXPORT___;
